import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import NewWeeklyClass from './NewWeeklyClass.js';
import { useTheme } from '../../../Context/ThemeContext';

export default function WeeklyClassBox(props) {
  const {
    rendering,
    setRendering,
    standardDate,
    isLoading,
    setIsLoading,
    isInProgress,
    setIsInProgress,
    scheduleData,
    breakTimeData,
    changedTeachers,
    canceledSchedules,
    setClickDate,
    onClickDeleteButton,
    onClickScheduleDetail,
    onClickPlusColumn,
    selectedCoaches = [], // 기본값 설정
    lessonSchedule
  } = props;

  const { isDark } = useTheme();

  const [standardDateList, setStandardDateList] = useState([]);

  // 매 주차 시작 일요일 뽑기 ( 해당 월 마지막 날이 포함될 때까지 ) //
  useEffect(() => {
    const weekStartDates = [];
    const lastDate = standardDate.clone().endOf('month');

    // day(0)은 로케일과 무관하게 해당 주의 일요일을 가리킴 //
    let weekStartDate = standardDate.clone().day(0);

    while (weekStartDate.isSameOrBefore(lastDate)) {
      weekStartDates.push(weekStartDate.clone());
      weekStartDate.add(7, 'days');
    }

    setStandardDateList(weekStartDates);
  }, [standardDate])

  return (
    <TopLevelWrapper $isDark={isDark}>
      {
        standardDateList.map((data, index) => (
          <WeeklyWrapper key={'WeeklyDates-' + index}>
            <NewWeeklyClass
              index={index}
              rendering={rendering}
              setRendering={setRendering}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isInProgress={isInProgress}
              setIsInProgress={setIsInProgress}
              scheduleData={scheduleData}
              breakTimeData={breakTimeData}
              changedTeachers={changedTeachers}
              canceledSchedules={canceledSchedules}
              today={data}
              setClickDate={setClickDate}
              onClickDeleteButton={onClickDeleteButton}
              onClickScheduleDetail={onClickScheduleDetail}
              onClickPlusColumn={onClickPlusColumn}
              selectedCoaches={selectedCoaches}
              lessonSchedule={lessonSchedule} />
          </WeeklyWrapper>
        ))
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: 20px;
  margin-bottom: 96px;

  width: 1020px;

  border-radius: 20px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
  
  transition: all 0.3s ease-in-out;
`;

const WeeklyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;
